/* projects/shared/src/lib/components/idba-mat-table-cell/idba-mat-table-cell.scss */
:host {
  display: block;
  width: 100%;
  min-width: 0;
}
.combo-box-field {
  width: 100%;
}
p {
  margin: 0;
  min-width: 0;
}
.currency {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-align: right !important;
}
a.mat-mdc-button.link-interno {
  padding: 0;
  font-size: 14px !important;
  text-align: start;
  min-width: 1em;
  text-decoration: underline;
  text-decoration-color: blue;
}
.image-column {
  max-width: 100%;
  max-height: 50px;
  object-fit: contain;
  padding: 3px;
}
/*# sourceMappingURL=idba-mat-table-cell.css.map */
